export default __webpack_public_path__ + "static/media/tpc_calc_profit_pie.41937146.svg";